import { transition } from '@helpers/animate';
import { ButtonReset } from '@helpers/global';
import { Device, from } from '@helpers/media';
import srOnly from '@helpers/srOnly';
import styled from 'styled-components';
const Container = styled.button `
  ${transition('background-size', 0.4)};
  ${ButtonReset};

  --buttonSize: 52px;

  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  align-items: center;
  border-radius: calc(var(--borderRadius) * 0.5);
  background: var(--colorBackground);
  background-image: linear-gradient(
    -67.65deg,
    var(--colorBackground) 50%,
    var(--colorBackgroundHover) 50%
  );
  background-repeat: no-repeat;
  background-size: 0% 100%;
  color: var(--colorText);
  height: var(--buttonSize);
  padding: 0px 18px;
  text-decoration: none;
  user-select: none;
  width: 100%;

  &.focus-ring {
    outline: auto;
    outline-offset: 3px;
    outline-color: var(--colorBackground);
  }

  span& {
    button:hover &,
    a:hover & {
      background-size: 245% 100%;
      &[data-type='outline']{
        color: var(--bgColor);
      }
    }
  }

  &:not(span) {
    cursor: pointer;

    &:hover {
      background-size: 245% 100%;
      &[data-type='outline']{
        color: var(--bgColor);
      }
    }
  }

  &[data-type='default'] {
    --colorBackground: var(--accentColorSecondary);
    --colorBackgroundHover: var(--accentColorPrimary);
    --colorText: var(--bgColor);
  }

  &[data-type='inverted'] {
    --colorBackground: var(--bgColor);
    --colorBackgroundHover: var(--accentColorSecondary);
    --colorText: var(--fgColor);
  }
  
  &[data-type='outline'] {
    --colorBackground: var(--bgColor);
    --colorBackgroundHover: var(--accentColorSecondary);
    --colorText: var(--fgColor);
    border: 3px solid var(--accentColorSecondary);
  }

  &[data-icon-only='true'] {
    height: var(--buttonSize);
    justify-content: center;
    padding: 0;
    width: var(--buttonSize);
  }

  /* Increase specificity to override :not(span) style */
  &:disabled:disabled:disabled {
    opacity: 0.6;
    pointer-events: none;
  }

  @media ${from(Device.MobileLarge)} {
    width: auto;
  }
`;
const Text = styled.span `
  font-weight: 700;

  color: currentColor;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.02em;
  text-decoration: none;
  text-transform: uppercase;

  ${Container}[data-icon-only='true'] & {
    ${srOnly};
  }
`;
const IconWrapper = styled.div `
  display: block;
  color: currentColor;
  margin: 0;
  padding: 0;

  > svg {
    display: block;
    height: 11px;
    width: auto;
  }

  ${Container}[data-icon-position='left'] & {
    order: -1;
  }

  ${Container}[data-icon-position='right'] & {
    order: 1;
  }

  ${Container}[data-icon-direction='left'] & {
    transform: rotate(180deg);
  }

`;
const ButtonStyles = {
    Container,
    IconWrapper,
    Text,
};
export default ButtonStyles;
